import { alpha, Grid, Input as muiInput, styled, Typography } from '@mui/material';

export const InputLogin = styled(muiInput)(({ theme }) => ({
    height: '56px',
    padding: '16px',
    borderRadius: '16px',
    marginTop: '5px',
    background: theme.palette.mode === 'dark' ? alpha(theme.palette.secondary.light, 0.04) : theme.palette.primary.contrastText,
}));

export const MailLoginTypography = styled(Typography)(({ theme }) => ({
    fontSize: '1.5rem',
    lineHeight: 1,
    color: theme.custom.c11,
    marginBottom: '24px',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.25rem',
    },
}));

export const InputTitleTypography = styled(Typography)(({ theme }) => ({
    width: 'fit-content',
    color: theme.palette.primary.contrastText,
}));

export const RightBlockGrid = styled(Grid)(({ theme }) => ({
    flexDirection: 'column',
    maxWidth: '630px',
    [theme.breakpoints.down('lg')]: {
        maxWidth: '527px',
        '&>svg': {
            maxWidth: '483px',
            height: 'auto',
        },
    },
}));

export const InfoGrid = styled(Grid)(({ theme }) => ({
    marginTop: '200px',
    marginLeft: '50px',
    gap: '30px',
    [theme.breakpoints.down('lg')]: {
        marginTop: '35px',
        marginLeft: '0',
        gap: '9px',
    },
}));

export const ForgotButtonsGrid = styled(Grid)(() => ({
    width: '400px',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
}));
